import { Component, ViewChild } from "@angular/core";
import {
  ModalController,
  IonInfiniteScroll,
  MenuController,
  ToastController,
  Platform,
  IonContent,
} from "@ionic/angular";
import { SearchPage } from "../search/search.page";
import { DetailsPage } from "../details/details.page";
import { TransactionsService } from "../../../api/transactions.service";
import { Router } from "@angular/router";
import { AppSettings } from "src/app/app-settings";

import { Idle, DEFAULT_INTERRUPTSOURCES } from "@ng-idle/core";
import { Subscription } from "rxjs";

@Component({
  selector: "app-list-offer",
  templateUrl: "list-offer.page.html",
  styleUrls: ["list-offer.page.scss"],
})
export class ListOfferPage {
  @ViewChild(IonInfiniteScroll) public infiniteScroll: IonInfiniteScroll;
  @ViewChild(IonContent) content: IonContent;

  public refreshDelay: number = 60000;
  public refreshSetinterval: any;
  public refreshedAt: any = new Date();
  public transactions: any[] = [];
  private currentPage: number;

  public loading: boolean;
  public refreshing: boolean;

  public filters: any;
  public filterSearchTerm: String;
  public isHistory: boolean;

  public applyFilters: boolean;
  public applyMatchingInventoryFilter: boolean = false;

  private listFunction;

  isWeb = AppSettings.IS_WEB;

  currentPath: String;

  idleState = "Not started.";
  timedOut = false;
  lastPing?: Date = null;
  private refreshInterval: any;
  idleEndSubscription: Subscription;

  constructor(
    public platform: Platform,
    public idle: Idle,
    public toastCtrl: ToastController,
    private modalController: ModalController,
    private transactionsService: TransactionsService,
    private router: Router,
    private menuCtrl: MenuController
  ) {

  }

  ionViewDidLeave() {
    if (this.idleEndSubscription) {
      this.idleEndSubscription.unsubscribe();
    }
    this.idle.stop();
    clearTimeout(this.refreshSetinterval);
  }

  ionViewDidEnter() {
    let t = this;
    t.menuCtrl.enable(AppSettings.IS_WEB);
    t.currentPage = 1;
    t.loading = true;

    if (
      t.router.url.split("/")[t.router.url.split("/").length - 1] === "tab1"
    ) {
      t.isHistory = false;
      t.listFunction = function (page) {
        t.refreshedAt = new Date();
        return t.transactionsService.list(
          page,
          t.applyFilters || t.applyMatchingInventoryFilter ? t.filters : {}
        );
      };

      t.idle.setIdle(5);
      t.idle.setTimeout(604800);
      t.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
      t.idleEndSubscription = t.idle.onIdleEnd.subscribe(() => {
      t.content.getScrollElement().then(scrollElement => {
        const scrollPosition = scrollElement.scrollTop;
        if (t.currentPage == 1 || scrollPosition == 0) {
          t.doRefresh(null);
        }
      });

    });

      this.idle.watch();
      this.refreshAfterDelay();
    } else {
      t.isHistory = true;
      t.listFunction = function (page) {
        let f = this.filters || {};
        if (f["matching_inventory"]) delete f["matching_inventory"];
        return t.transactionsService.history(
          page,
          t.applyFilters || t.applyMatchingInventoryFilter ? f : {}
        );
      };
    }
    t.transactionsService.getFilters(t.isHistory).then(async (response) => {
      t.filters = response ? response : {};

      t.applyFilters = t.filters.applyFilters;
      t.applyMatchingInventoryFilter = t.filters.matching_inventory;
      t.listFunction(1)
        .then((response) => {
          t.transactions = response["results"];
          t.loading = false;
        })
        .catch(() => {
          t.loading = false;
          t.applyFilters = false;
        });
    });
  }

  async openFilterModal() {
    let t = this;

    t.transactionsService.getFilters(this.isHistory).then(async (response) => {
      const modal = await t.modalController.create({
        component: SearchPage,
        componentProps: {
          filters: this.filters,
          isHistory: this.isHistory,
        },
        cssClass: !this.isWeb ? "modal-fullscreen" : "",
      });

      modal.present();
      modal.onWillDismiss().then((filters) => {
        t.currentPage = 1;

        if (filters.data) t.filters = filters.data;

        if (this.isHistory && t.filters["matching_inventory"])
          delete t.filters["matching_inventory"];
        t.applyFilters = t.filtersAreSet();
        t.doRefresh(null);
      });
    });
  }

  async openDetailsModal(transactionId: any) {
    const modal = await this.modalController.create({
      component: DetailsPage,
      componentProps: {
        transactionId: transactionId,
      },
      cssClass: !this.isWeb ? "modal-fullscreen" : "modal-customscreen",
    });

    return await modal.present();
  }

  filtersAreSet() {
    let f = this.filters;
    let r = f
      ? (f["transaction_type"] ? f["transaction_type"] != "ANY" : false) ||
      f["reference"] ||
      (f["condition"] ? f["condition"] != "ANY" : false) ||
      (f["selectedPeriod"] ? f["selectedPeriod"] != "ANY" : false)
      : false;
    return r;
  }

  doRefresh(event) {
    let t = this;
    setTimeout(() => {
      t.currentPage = 1;
      t.refreshing = true;

      t.listFunction(this.currentPage, this.filters)
        .then((response) => {
          if (!!event) event.target.complete();
          t.transactions = response["results"];
        })
        .catch(() => {
          if (!!event) event.target.complete();
          t.transactions = [];
        })
        .finally(() => {
          t.infiniteScroll.disabled = false;
          t.refreshing = false;
          t.refreshedAt = new Date();
        });
    }, 0);
  }

  loadData(event) {
    let t = this;
    this.currentPage++;
    this.refreshing = true;
    this.listFunction(this.currentPage, this.filters)
      .then((response) => {
        t.transactions = t.transactions.concat(response["results"]);
        event.target.complete();
        if (t.transactions.length >= 1000) {
          event.target.disabled = true;
        }
      })
      .catch(() => {
        event.target.disabled = true;
      })
      .finally(() => {
        t.refreshing = false;
      });
  }

  handleToggleMatchingInventoryFilter(artificial) {
    let t = this;
    if (artificial)
      this.applyMatchingInventoryFilter = !this.applyMatchingInventoryFilter;
    setTimeout(() => {
      let f = {};

      // Uncomment this if filter are re-implemented nd check if it triggers again issue #22 (project-followup)
      // if(this.applyFilters) {
      f = this.filters;

      // }
      t.loading = true;
      f["matching_inventory"] = this.applyMatchingInventoryFilter
        ? this.applyMatchingInventoryFilter
        : false;
      this.transactionsService.setFilters(f, this.isHistory).then((r) => {
        t.currentPage = 1;
        t.transactionsService
          .list(this.currentPage, f)
          .then((response) => {
            t.transactions = response["results"];
          })
          .catch(() => { })
          .finally(() => {
            t.loading = false;
            t.infiniteScroll.disabled = false;
          });
      });
    }, 0);
  }

  handleToggleFilters() {
    setTimeout(() => {
      let f = this.filters || {};
      f["applyFilters"] = this.applyFilters;
      this.transactionsService.setFilters(f, this.isHistory).then((r) => {
        if (this.applyFilters && !this.filtersAreSet()) this.openFilterModal();
        else {
          f["matching_inventory"] = this.applyMatchingInventoryFilter;
          this.currentPage = 1;
          this.listFunction(1)
            .then((response) => {
              this.transactions = response["results"];
            })
            .catch(() => { });
        }
      });
    }, 0);
  }

  async searchFilterList(evt) {
    // this.foodList = this.foodListBackup;
    let t = this;
    let f = {};

    const searchTerm = evt.srcElement.value;

    f = this.filters;

    t.loading = true;

    if (!searchTerm) {
      t.filterSearchTerm = ""
      if (f["reference"]) delete f["reference"];

      t.listFunction(this.currentPage, this.filters)
        .then((response) => {
          t.transactions = response["results"];
        })
        .catch(() => {
          t.transactions = [];
        })
        .finally(() => {
          t.loading = false;
          t.applyFilters = false
        });
      return;
    }
    t.filterSearchTerm = searchTerm
    f["reference"] = t.filterSearchTerm
    t.applyFilters = true
    this.transactionsService.setFilters(f, this.isHistory).then((r) => {
      t.currentPage = 1;
      t.transactionsService
        .list(this.currentPage, f)
        .then((response) => {
          t.transactions = response["results"];
        })
        .catch(() => { })
        .finally(() => {
          t.loading = false;
          t.infiniteScroll.disabled = false;
        });
    });


    // return  t.transactionsService
    //   .getFilters(this.isHistory)
    //   .then(async (response) => {
    //     t.filters = response;
    //     t.applyFilters = t.filters.applyFilters
    //       ? t.filters.applyFilters
    //       : false;
    //     t.applyMatchingInventoryFilter = response["matching_inventory"];
    // });
  }

  getFilters() {
    let t = this;
    return this.transactionsService
      .getFilters(this.isHistory)
      .then(async (response) => {
        t.filters = response;
        t.applyFilters = t.filters.applyFilters
          ? t.filters.applyFilters
          : false;
        t.applyMatchingInventoryFilter = response["matching_inventory"];
      });
  }

  refreshAfterDelay() {
    let t = this;
    this.refreshSetinterval = setInterval(() => {
      if (!t.idle.isIdling()) {
        t.content.getScrollElement().then(scrollElement => {
          const scrollPosition = scrollElement.scrollTop;
          if (t.currentPage == 1 || scrollPosition == 0)
            t.doRefresh(null);
        });
      }
    }, t.refreshDelay);
  }


}
